export type Dir = "bull" | "bear";

export interface Swing { index: number; price: number; time: number }

export interface StructureEvent {
  index: number;
  from: number;
  price: number;
  dir: Dir;
  type: "BOS" | "CHoCH";
  time: number;
}

export interface FVG { index: number; top: number; bottom: number; dir: Dir }
export interface OrderBlock { index: number; top: number; bottom: number; dir: Dir }
export interface LiquidityLevel { indices: number[]; price: number; kind: "EQH" | "EQL" }

export interface StructureResult {
  highs: Swing[];
  lows: Swing[];
  events: StructureEvent[];
  fvg: FVG[];
  obs: OrderBlock[];
  liquidity: LiquidityLevel[];
  trend: "up" | "down" | null;
  cisd?: import("./CisdEngine").CisdResult | null;
  t50?: import("../strategies/t50/T50Engine").T50Result | null;
  twoBOneA?: (import("./twoBOneA/TwoBOneAEngine").TwoBOneAResult & { fresh: import("./twoBOneA/TwoBOneAEngine").TwoBOneAEvent[] }) | null;
}

export interface StructureFlags {
  swings: boolean;
  bos: boolean;
  choch: boolean;
  cisd?: boolean;
  t50?: boolean;
  twoBOneA?: boolean;
  fvg: boolean;
  ob: boolean;
  liq: boolean;
}

export interface StructureSettings {
  lookback: number;
  eqTolerance: number; // fraction of avg range for equal highs/lows
  t50?: Partial<import("../strategies/t50/T50Engine").T50Config>;
  twoBOneAState?: import("./twoBOneA/TwoBOneAEngine").TwoBOneAState; // incremental live detector (owned by the chart)
  twoBOneAMode?: import("./twoBOneA/TwoBOneAEngine").TwoBOneAMode; // "tick" on the 1s synthetic series, "ohlc" otherwise
}

export const DEFAULT_STRUCTURE_SETTINGS: StructureSettings = { lookback: 2, eqTolerance: 0.15 };
